<template>
  <v-app>
    <default-bar clipped-right />

    <default-drawer />

    <!-- Patrol panel at the top for small screens -->
    <transition name="slide-down" mode="out-in">
      <v-sheet v-if="!isLargeScreen && patrolDrawer" key="top-patrol-panel" class="patrol-panel-top elevation-2 drawer"
        :style="patrolPanelStyle">
        <patrols-horizontal></patrols-horizontal>
      </v-sheet>
    </transition>

    <default-view :patrol-panel-visible="!isLargeScreen && patrolDrawer"
      :right-patrol-panel-visible="isLargeScreen && patrolDrawer" :right-panel-width="drawerWidth" ref="defaultView" />

    <default-footer />

    <!-- Patrol panel on the side for large screens -->
    <transition name="slide-right" mode="out-in">
      <v-navigation-drawer v-if="isLargeScreen && patrolDrawer" key="right-patrol-panel" class="elevation-4 drawer" app
        right permanent clipped :width="drawerWidth">
        <patrols></patrols>
        <default-settings v-if="false" />
      </v-navigation-drawer>
    </transition>
  </v-app>
</template>

<script>
  // Utilities
  import { sync } from 'vuex-pathify'

  export default {
    name: 'DefaultLayout',

    computed: {
      ...sync('app', ['drawer']),
      ...sync('user', ['patrolDrawer']),
      mini: sync('user/drawer@mini'),
      isLargeScreen() {
        return this.$vuetify.breakpoint.lgAndUp
      },
      drawerWidth() {
        // Dynamic width depending on screen size
        if (this.$vuetify.breakpoint.xl) return 350
        if (this.$vuetify.breakpoint.lg) return 300
        return 280
      },
      leftDrawerWidth() {
        // Width of the left drawer
        if (!this.drawer) return 0
        return this.mini ? 80 : 260
      },
      patrolPanelStyle() {
        // Dynamic style for patrol panel at the top
        // On medium and larger screens consider drawer width
        if (this.$vuetify.breakpoint.mdAndUp && this.drawer) {
          const leftMargin = this.leftDrawerWidth
          return {
            marginLeft: `${leftMargin}px`,
            width: `calc(100% - ${leftMargin}px)`,
          }
        }
        // Full width on small screens
        return {
          marginLeft: '0px',
          width: '100%',
        }
      },
    },

    watch: {
      // Don't automatically open panel - user controls via button
      // isLargeScreen: {
      //   handler(val) {
      //     this.patrolDrawer = val
      //   },
      //   immediate: true
      // }
    },



    components: {
      DefaultBar: () =>
        import(
          /* webpackChunkName: "default-app-bar" */
          './AppBar'
        ),
      DefaultDrawer: () =>
        import(
          /* webpackChunkName: "default-drawer" */
          './Drawer'
        ),
      DefaultFooter: () =>
        import(
          /* webpackChunkName: "default-footer" */
          './Footer'
        ),
      DefaultSettings: () =>
        import(
          /* webpackChunkName: "default-settings" */
          './Settings'
        ),
      DefaultView: () =>
        import(
          /* webpackChunkName: "default-view" */
          './View'
        ),
      Patrols: () =>
        import(
          /* webpackChunkName: "dashboard-patrols" */
          '../../components/patrol/PatrolsVertical'
        ),
      PatrolsHorizontal: () =>
        import(
          /* webpackChunkName: "dashboard-patrols-horizontal" */
          '../../components/patrol/PatrolsHorizontal'
        ),
    },
  }
</script>

<style scoped>
  .patrol-panel-top {
    position: fixed;
    top: 64px;
    left: 0;
    z-index: 4; /* Lower than v-main content but higher than background */
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    transition: margin-left 0.3s ease, width 0.3s ease;
  }

  /* Slide down animation */
  .slide-down-enter-active,
  .slide-down-leave-active {
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  }

  .slide-down-enter {
    transform: translateY(-100%);
    opacity: 0;
  }

  .slide-down-leave-to {
    transform: translateY(-100%);
    opacity: 0;
  }

  /* Slide right animation */
  .slide-right-enter-active,
  .slide-right-leave-active {
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  }

  .slide-right-enter {
    transform: translateX(100%);
    opacity: 0;
  }

  .slide-right-leave-to {
    transform: translateX(100%);
    opacity: 0;
  }

  @media (max-width: 600px) {
    .patrol-panel-top {
      top: 56px; /* AppBar is lower on mobile */
    }
  }

  /* On very small screens hide drawer and show full width */
  @media (max-width: 960px) {
    .patrol-panel-top {
      margin-left: 0 !important;
      width: 100% !important;
    }
  }
</style>
